// extracted by mini-css-extract-plugin
export default {"light":"theme_light__Fs9mQ","dark":"theme_dark__RJ-3k","btn":"theme_btn__1Qr48","select":"theme_select__RsP-Z","container":"theme_container__KDDAf"};